import React, { useEffect } from "react";
import Container from "../../../utils/Container";
import successMas from "../../../assets/success.png";
import { useNavigate } from "react-router";
import { secureStorage } from "../../../utils/secureStorage";

const TourBookingSuccess = () => {
  const navigate = useNavigate();
  useEffect(() => {
    secureStorage.removeItem("BookTour");
  }, []);
  return (
    <div>
      <Container>
        <div className="flex flex-col items-center justify-center h-full py-32">
          <div className="w-1/2 lg:w-52 h-full">
            <img
              src={successMas}
              className="w-full h-full object-contain"
              alt=""
            />
          </div>
          <p className="text-lg font-semibold text-center">
            Congratulations 🎉! You have successfully booked your tour. <br />
            Check your email for confirmation details. Happy Journey
          </p>
          <div className="mt-8">
            <button
              className="bg-[#161f52] hover:bg-[#0a0e25] duration-300 text-white font-bold py-2 px-4 rounded"
              onClick={() => navigate("/customer/dashboard")}
            >
              Check Your Booking
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TourBookingSuccess;
